import { render } from "./LzModal.vue?vue&type=template&id=96f0283e"
import script from "./LzModal.vue?vue&type=script&lang=js"
export * from "./LzModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__